var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import timezone from 'moment-timezone';
import moment from 'moment';
import { getFullLine as getFullLineAction, clearLine as clearLineAction, fetchPreMatchMenu as fetchPreMatchMenuAction } from '../../../actions/creators/lines';
import { setActiveTab as setActiveTabAction } from '../../../actions/creators/sidebar';
import { isSlotTypeFavorite, _getFavoriteSlotTypesFromLocalStorage } from './slots/SlotLocalStorageManager';
import slotTypeProvider from '../providers/SlotTypeProvider';
import slotIdProvider from '../providers/SlotIdProvider';
import slotFamilyProvider from '../providers/SlotFamilyProvider';
import slotFactory from '../factories/SlotFactory';
import PreMatchHeader from './preMatchHeader';
import LiveHeader from './liveHeader';
import SlotArrangementPolicy from '../slot-arrangement-policies';
import ToggledSections from './toggled-outcomes';
import slotComponentFactory from './slotComponentFactory';
import FinishImage from '../../../assets/img/finish.svg';
import { defineMessages, injectIntl } from 'react-intl';
import { localization } from '../../../containers/gridLocalization';
var messages = defineMessages({
    sports_no_markets: {
        id: 'sports.no_markets',
        defaultMessage: 'Нет доступных исходов'
    },
    sports_no_events_title: {
        id: 'sports.no_events_title',
        defaultMessage: 'Событие недоступно'
    },
    sports_no_events: {
        id: 'sports.no_events',
        defaultMessage: 'Событие, которое вы просматривали, завершено или больше не доступно.'
    },
    sports_no_events_btn_sport: {
        id: 'sports.no_events_btn_sport',
        defaultMessage: 'Весь спорт'
    }
});
function slotPositionComparator(a, b) {
    if (a.position > b.position) {
        return 1;
    }
    if (a.position < b.position) {
        return -1;
    }
    return 0;
}
function getSlots(match, outcomes) {
    var realSportId = match.get('realSportId');
    var sportId = match.get('sportId');
    var slotsMap = {};
    var slots = [];
    outcomes.forEach(function (o) {
        var slotType = slotTypeProvider(realSportId, o.get('type'));
        var slotFamily = slotFamilyProvider(realSportId, slotType);
        var slotFavorite = isSlotTypeFavorite(slotType, realSportId);
        var slotId = slotIdProvider(slotType, slotFamily, o);
        var slot = slotsMap[slotId];
        if (slot === undefined) {
            slot = slotFactory(slotId, slotType, slotFamily, o);
            slotsMap[slotId] = slot;
            slot.position = SlotArrangementPolicy.getPosition(realSportId, 1, slot);
            if (ToggledSections[realSportId] !== undefined) {
                slot.toggled = !!ToggledSections[realSportId].find(function (s) { return s === slot.type; });
            }
            slot.sportId = sportId;
            slot.favorite = slotFavorite;
            slots.push(slot);
        }
        slot.outcomes.push(o.get('id'));
    });
    slots.sort(slotPositionComparator);
    return slots;
}
function getFavoriteSlots(slots, sportId) {
    var resultFavoriteSlots = [];
    var favoriteSlots = slots.filter(function (slot) { return slot.favorite === true; });
    var favoriteSlotTypes = _getFavoriteSlotTypesFromLocalStorage(sportId);
    favoriteSlotTypes.forEach(function (slotType) {
        resultFavoriteSlots = resultFavoriteSlots.concat(favoriteSlots.filter(function (slot) { return slot.type === slotType; }));
    });
    return resultFavoriteSlots;
}
function getTypicalSlots(slots) {
    return slots.filter(function (slot) { return slot.favorite === false; });
}
function renderSlots(slots, match, outcomes, languageId, rates, gridLocalization, section) {
    var sportId = match.get('realSportId');
    var matchObj = {
        homeTeam: match.get('firstTeam'),
        awayTeam: match.get('secondTeam')
    };
    var slotElements = [];
    var i = 0;
    slots.map(function (slot) {
        var filteredOutcomes = outcomes
            .filter(function (outcome) { return slot.outcomes.includes(outcome.get('id')); })
            .map(function (o) {
            return o.set('name', gridLocalization.getOutcomeName(sportId, o.toJS(), matchObj));
        });
        var filteredRates = rates
            .filter(function (r) { return slot.outcomes.includes(r.get('outcomeId')); })
            .map(function (r) {
            var outcome = filteredOutcomes.get(r.get('outcomeId'));
            return r.set('shortName', gridLocalization.getRateName(sportId, outcome.toJS(), r.get('type'), matchObj));
        });
        var key = slot.id;
        var SlotRenderer = slotComponentFactory(slot.family);
        var props = {
            slot: slot,
            match: match,
            filteredRates: filteredRates,
            outcomes: filteredOutcomes,
            gridLocalization: gridLocalization,
            section: section,
            languageId: languageId,
            expanded: i === 0
        };
        slotElements.push(_createElement(SlotRenderer, __assign({}, props, { key: key })));
        i++;
    });
    return slotElements;
}
var Event = /** @class */ (function (_super) {
    __extends(Event, _super);
    function Event() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Event.prototype.componentWillMount = function () {
        var _a = this.props, eventId = _a.eventId, languageId = _a.languageId, section = _a.section;
        root.scrollTo(0, 0);
        if (section === 'preMatchEvent') {
            this.props.getFullLineAction({ eventId: eventId, languageId: languageId });
        }
        else {
            this.props.clearLineAction();
        }
    };
    Event.prototype.componentDidMount = function () {
        var tab = this.props.section === 'live' ? 'live' : 'sport';
        this.props.setActiveTabAction(tab);
    };
    Event.prototype.shouldComponentUpdate = function (nextProps) {
        return (nextProps.isMatchNotFound !== this.props.isMatchNotFound || nextProps.history !== this.props.history || nextProps.location !== this.props.location || nextProps.match !== this.props.match || nextProps.intl !== this.props.intl);
    };
    Event.prototype.render = function () {
        var _a = this.props, fetching = _a.fetching, match = _a.match, sportName = _a.sportName, sportId = _a.sportId, leagueName = _a.leagueName, activeTab = _a.activeTab, gridLocalization = _a.gridLocalization, section = _a.section, languageId = _a.languageId, intl = _a.intl, isMatchNotFound = _a.isMatchNotFound;
        if (fetching) {
            return (_jsx("div", __assign({ className: 'content' }, { children: _jsx("div", { className: 'please_wait' }) })));
        }
        if (isMatchNotFound) {
            return (_jsxs("div", __assign({ className: 'content', id: 'content' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: intl.formatMessage(messages.sports_no_events_title) }) }), _jsxs("div", __assign({ className: 'no_events' }, { children: [_jsx("img", { src: FinishImage, alt: '' }), _jsx("div", __assign({ className: 'no_events__title' }, { children: intl.formatMessage(messages.sports_no_events_title) })), _jsx("div", __assign({ className: 'no_events__info' }, { children: intl.formatMessage(messages.sports_no_events) })), _jsx(Link, __assign({ className: 'no_events__btn_sport', to: '/sport' }, { children: intl.formatMessage(messages.sports_no_events_btn_sport) }))] }))] })));
        }
        if (match === undefined) {
            return false;
        }
        var name = match.get('name');
        var tv = match.get('channel');
        var startDate = match.get('startDate');
        var tzGuess = timezone.tz.guess();
        var date = moment.tz(startDate, tzGuess).clone();
        var slots = getSlots(match, this.props.outcomes);
        var renderHeader;
        var props = {
            sportId: sportId,
            leagueName: leagueName,
            name: name,
            date: date,
            languageId: languageId,
            tv: tv
        };
        if (activeTab === 'live') {
            var liveProps = __assign(__assign({}, props), { match: match, gridLocalization: gridLocalization, section: section });
            renderHeader = _jsx(LiveHeader, __assign({}, liveProps));
        }
        else {
            var preMatchProps = __assign(__assign({}, props), { sportName: sportName, goBack: this.props.history.goBack, leagueId: match.get('leagueId') });
            renderHeader = _jsx(PreMatchHeader, __assign({}, preMatchProps));
        }
        var realSportId = match.get('realSportId');
        var favoriteSlots = getFavoriteSlots(slots, realSportId);
        var typicalSlots = getTypicalSlots(slots);
        return (_jsx("div", __assign({ className: 'content', id: 'content' }, { children: _jsxs("div", __assign({ className: 'block blc_event' }, { children: [renderHeader, match.get('isBlocked') && _jsx("div", __assign({ className: 'no_outcomes' }, { children: intl.formatMessage(messages.sports_no_markets) })), !match.get('isBlocked') && renderSlots(favoriteSlots, match, this.props.outcomes, languageId, this.props.rates, gridLocalization, section), !match.get('isBlocked') && renderSlots(typicalSlots, match, this.props.outcomes, languageId, this.props.rates, gridLocalization, section)] })) })));
    };
    return Event;
}(React.Component));
Event.propTypes = {
    fetchPreMatchMenuAction: PropTypes.func.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    fetching: PropTypes.bool.isRequired,
    eventId: PropTypes.number.isRequired,
    sportName: PropTypes.string,
    sportId: PropTypes.any,
    leagueName: PropTypes.string,
    match: PropTypes.object,
    outcomes: PropTypes.object,
    rates: PropTypes.object,
    section: PropTypes.string.isRequired,
    activeTab: PropTypes.string.isRequired
};
function mapStateToProps(state, props) {
    var section = 'preMatchEvent';
    var eventId = props.eventId || +props.match.params.eventId;
    var match = state.application.getIn([section, 'matches', eventId]);
    var outcomes = state.application.getIn([section, 'outcomes'])
        .filter(function (outcome) { return outcome.get('matchId') === eventId; });
    var rates = state.application.getIn([section, 'rates'])
        .filter(function (rate) { return rate.get('matchId') === eventId; });
    var sportName = '';
    var sportId = '';
    var leagueName = '';
    if (match) {
        sportId = state.application.getIn([section, 'sports', match.get('sportId')]).get('id');
        sportName = state.application.getIn([section, 'sports', match.get('sportId')]).get('name');
        leagueName = state.application.getIn([section, 'leagues', match.get('leagueId')]).get('name');
    }
    return {
        eventId: eventId,
        languageId: state.application.get('languageId'),
        fetching: state.application.getIn(['preMatch', 'fetching']),
        isMatchNotFound: state.application.getIn(['preMatch', 'isMatchNotFound']),
        sportId: sportId,
        sportName: sportName,
        leagueName: leagueName,
        match: match,
        outcomes: outcomes,
        section: section,
        rates: rates,
        gridLocalization: localization(state.application.get('languageId')),
        activeTab: state.application.get('activeTab')
    };
}
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    getFullLineAction: getFullLineAction,
    setActiveTabAction: setActiveTabAction,
    fetchPreMatchMenuAction: fetchPreMatchMenuAction,
    clearLineAction: clearLineAction
}, dispatch); };
Event = connect(mapStateToProps, mapDispatchToProps)(Event);
export default withRouter(injectIntl(Event));



// WEBPACK FOOTER //
// ./src/components/grid/event/index.js